import React, { useEffect, useState } from "react";
import cartContext from "../Context/cartContext";
import { useContext } from "react";
import Footer from "../homeComponents/footer";
import './cart.css';
import GppGoodIcon from '@mui/icons-material/GppGood';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function Cart() {
    const { cart, setCart } = useContext(cartContext);
    const [item,setItem1] = useState(JSON.parse(localStorage.getItem('userCart')));
    const [total, setTotal] = useState({
        currentPrice: 0,
        originalPrice: 0,
        discount: 0
    });
    const navigate = useNavigate();
    // let total = 0;
    const z = localStorage.getItem('islogin');
    

    useEffect(() => {
        let a = 0;
        let b = 0;
        let c = 0;

      (item &&  item.map((it) => {
            a += Number(it.OriginalPrice);
            b += Number(it.currentPrice);
            c += Number(it.offer);
        }))
        
        setTotal({ originalPrice: a, currentPrice: b, discount: a - b, });
    }, [cart,item]);
    return (
        <div className="cartMain">
            <div>
                <img src="https://assets.ajio.com/cms/AJIO/WEB/28032021-D-cartpagebanner-relianceones.jpg" alt="" className="cartImage" />
                <div className="cartDesign">
                    <div >
                        <span><h3 className="cartHeading">My Bag</h3>({item ? item.length : 0} items)</span>
                        <button className="cartFromWishlist btn " onClick={()=>{
                            navigate('/wishlist')
                        }}>+ Add From WishList</button>
                 { item ?   item.map((it,idx) => {
                                return (
                                    <div className="cartItem" key={idx}>
                                        <div className="imgItem">
                                            <img src={it.image} alt="" className="itemImage" />
                                            <h3 className="cartBrand">{it.type}</h3>
                                        </div>
                                        <div className="cartPrice">
                                            <span className="itemOrginalPrice">{it.OriginalPrice ? `Rs. ${it.OriginalPrice}` : ""}</span>
                                            <span className="itemOffer">{it.offer ? `(${it.offer}%)` : ""} </span>
                                            <h5 className="itemCurrentPrice">Rs.{it.currentPrice} </h5>
                                            <div type="submit" className="cartDelete" ><button className="btn btn-outline-danger" onClick={() => {
                                                let ans1 = cart.filter((a) => {
                                                    return a.id != it.id;
                                                })
                                                setCart(ans1);
                                                let ans = item.filter((a) => {
                                                    return a.id != it.id;
                                                })
                                                if(ans.length != 0){
                                                    localStorage.setItem("userCart",JSON.stringify(ans));
                                                    setItem1(JSON.parse(localStorage.getItem("userCart")))
                                                }else{
                                                    localStorage.removeItem('userCart')
                                                    setItem1();
                                                }
                                                
                                                setCart(ans);
                                                toast.error("You remove item to cart", {
                                                    position: "top-right",
                                                    autoClose: 3000,
                                                    hideProgressBar: false,
                                                    closeOnClick: true,
                                                    pauseOnHover: true,
                                                    draggable: true,
                                                    progress: undefined,
                                                    theme: "light",
                                                    });
                                            }} type="button" >Delete</button>
                                            </div>
                                        </div>

                                    </div>

                                )
                            })
                          :
                        <h1 className="cartEmpty">Your Shopping Bag is Empty!!</h1>
                               }
                    </div>
                    <div className="cartCalculation">
                        <div className="cartTotal">
                            <h4 className="orderHeading">Order Details</h4>
                            <div className="cartOrderDetail">
                                <div>
                                    <h5 className="bagName">Bag Total</h5>
                                    <h5 className="bagName">Bag Discount</h5>
                                    <h5 className="bagName">Delivery Fee</h5>
                                    <h4 className="bagName">Order Total</h4>
                                </div>
                                <div>
                                    <h6>{<i class="fa-solid fa-indian-rupee-sign digit"></i>} {total.originalPrice}</h6>
                                    <h6 className="cartDiscount">- {<i class="fa-solid fa-indian-rupee-sign digit"></i>} {total.discount}</h6>
                                    <h6 className="deliveryFees">{<i class="fa-solid fa-indian-rupee-sign digit"></i>} 99</h6>
                                    <h6>{<i class="fa-solid fa-indian-rupee-sign digit"></i>} {total.currentPrice}</h6>

                                </div>
                            </div>
                            <button className="paymentButton" type="submit"  onClick={()=>{
                             (total.currentPrice && z=='yes') ? navigate('./payment') 
                             : (!total.currentPrice ?
                             alert('Please add items in cart')
                             :
                                alert('Please login first'));
                            
                            }}>PROCEED TO PAYMENT</button>
                        </div>
                        <div className="returnPolicy">
                            <span className="returnPolicyHeading">Return/Refund policy</span>

                            <p className="returnPolicyParagraph">In case of return, we ensure quick refunds. Full amount will be refunded excluding Convenience Fee</p>

                            <span className="returnPolicyPoint">Read Policy</span>
                        </div>
                    </div>
                </div>
               
            </div>
          

          <ul className="cartFirstFlex" type="none">
             <li className="cartFlexItem"><span><GppGoodIcon /></span> SECURE PAYMENTS</li>
             <li  className="cartFlexItem"><span><CurrencyRupeeIcon /></span> CASH ON DELIVERY</li>
             <li  className="cartFlexItem"><span><CheckCircleOutlineIcon /></span> ASSURED QUALITY</li>
             <li  className="cartFlexItem"><span><i class="fa-solid fa-rotate"></i></span> EASY RETURN</li>

          </ul>


            <ul className='homeFlex cartSecondFlex' type="none">
                <div>
                    <li className='homeIcon'><i class="fa-solid fa-camera-rotate"></i></li>
                    <li><h4>EASY EXCHANGE</h4></li>
                </div>
                <div>
                    <li className='homeIcon'><i class="fa-solid fa-hand-holding-heart"></i></li>
                    <li><h4>100% HANDPICKED</h4></li>
                </div>
                <div>
                    <li className='homeIcon'><i class="fa-sharp fa-solid fa-circle-check"></i></li>
                    <li><h4>ASSURED QUALITY</h4></li>
                </div>
            </ul>
            
            <Footer />
            <ToastContainer />
        </div>
    )
}